import React from "react";
import LinkComp from "../LinkComp";

export default () => {
  return (
    <header className="Header">
      <div className="Header_wrap">
        <LinkComp className="Header_logo" to={arc.path.base}>
          <img src={arc.path.media + "summit.svg"} alt="" />
        </LinkComp>
        <div className="Header_quote">
          "SUMMIT - Excellence in Commercial Real Estate"
        </div>
      </div>
    </header>
  );
};
